export default __webpack_public_path__ + "static/media/134.313e4beb.webp";